export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 'var(--radius-md)',
    borderColor: state.isFocused ? 'var(--brand)' : 'var(--border-subtle)',
    backgroundColor: 'var(--surface-panel)',
    color: 'var(--text-primary)',
    boxShadow: state.isFocused ? 'var(--focus-ring)' : '0 1px 2px rgba(15, 23, 42, 0.05)',
    cursor: 'pointer',
    transition: 'border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease',
    ':hover': {
      borderColor: state.isFocused ? 'var(--brand)' : 'var(--border-strong)',
    },
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
  input: (base) => ({ ...base, color: 'var(--text-primary)' }),
  singleValue: (base) => ({ ...base, color: 'var(--text-primary)' }),
  placeholder: (base) => ({ ...base, color: 'var(--text-muted)' }),
  indicatorsContainer: (base) => ({ ...base, color: 'var(--text-muted)' }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? 'var(--brand)' : 'var(--text-muted)',
    ':hover': { color: 'var(--brand)' },
  }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--border-subtle)' }),
  menu: (base) => ({
    ...base,
    zIndex: 60,
    overflow: 'hidden',
    border: '1px solid var(--border-subtle)',
    borderRadius: 'var(--radius-md)',
    backgroundColor: 'var(--surface-raised)',
    boxShadow: 'var(--shadow-popover)',
  }),
  menuList: (base) => ({ ...base, padding: 4 }),
  menuPortal: (base) => ({ ...base, zIndex: 1200 }),
  option: (base, state) => ({
    ...base,
    borderRadius: 'var(--radius-sm)',
    backgroundColor: state.isSelected
      ? 'var(--brand-soft)'
      : state.isFocused
        ? 'var(--surface-panel-muted)'
        : 'transparent',
    color: state.isSelected ? 'var(--brand-strong)' : 'var(--text-primary)',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    opacity: state.isDisabled ? 0.55 : 1,
    ':active': { backgroundColor: 'var(--brand-soft)' },
  }),
  noOptionsMessage: (base) => ({ ...base, color: 'var(--text-muted)' }),
  loadingMessage: (base) => ({ ...base, color: 'var(--text-muted)' }),
};
